<template>
  <div>
    <div class="section">
      <form-wizard
        ref="wizard"
        title=""
        subtitle=""
        shape="square"
        back-button-text="back"
        next-button-text="next"
        finish-button-text="submit"
        color="dodgerblue"
        @on-complete="onComplete"                    
      >
        <tab-content
          ref="stepone"
          :title="$t('Quote.ServiceType')"
          icon="now-ui-icons design_app"
          :before-change="()=>{ return validateStep1() }"
          >
          <div class="section">
            <div class="container col-md-8">
              <div class="row">
                <div class="ml-auto mr-auto gap">      
                  <h3 v-html="$t('Quote.Request')">
                    Request a quote<span class="tpgreen">.</span class="tpgreen"></span>
                  </h3>                               
                </div>
              </div>


              <div>
                <div class="container1">
                  <div
                    class="row elgrey"
                    style="padding-top:25px"
                  >
                    <div
                      class="col-6 col-sm-6 elmaster"
                      @click="onChangeService('W')"
                    >
                      <card>
                        <img
                          slot="image"
                          class="card-img-top"
                          src="img/whse.jpg"
                          alt="Card image cap"
                        >              
                        <h5
class="card-title"
v-html="$t('General.WarehouseDistribution')"
>
Warehousing and Distribution
</h5>                
                      </card>
                    </div>

                    <div
                      class="col-6 col-sm-6 elmaster"
                      @click="onChangeService('T')"
                    >
                      <card>
                        <img
                          slot="image"
                          class="card-img-top"
                          src="img/freight.jpg"
                          alt="Card image cap"
                        >              
                        <h5
                          class="card-title"
                          v-html="$t('Quote.TransFreight')"
                        >
                          Transportation
                        </h5>
                      </card>
                    </div>
                  </div>
                </div>
              </div>
</div>
          </div>                          
        </tab-content>

        <!-- WAREHOUSING -->
        <!--<tab-content title="Additional Info" icon="now-ui-icons ui-1_settings-gear-63" :before-change="() => { return ((this.main.service === 'W')? this.validateWarehouse() : this.validateTransport()) }">              -->
        <tab-content
:title="$t('Quote.AdditionalInformation')"
icon="now-ui-icons ui-1_settings-gear-63"
:before-change="()=>{ return validateStep2() }"
>
          <div v-if="main.service === 'W'">
            <div class="col-md-10 ml-auto mr-auto text-left">
              <h3
class="col-md-10 ml-auto mr-auto text-center"
v-html="$t('General.WarehouseDistribution')"
>
                Warehousing and Distribution<span class="tpgreen">.</span class="tpgreen"></span>
              </h3>
              <!--<h1 class="title">Warehousing</h1>-->

              <div class="row">
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Location')"
                  >Location</label>
                  <select
                    v-model.trim="$v.warehouse.location.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.warehouse.location.$error }"
                  >
                    <!--<select v-model="warehouse.location" class="form-item__element form-item__element--select form-control" required>-->
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option value="Quebec">
                      CA - Quebec
                    </option>
                    <option value="Ontario">
                      CA - Ontario
                    </option>
                    <option value="Alberta">
                      CA - Alberta
                    </option>
                    <option value="British Columbia">
                      CA - British Columbia
                    </option>
                    <option value="North East">
                      US - North East
                    </option>
                    <option value="Ontario">
                      US - South East
                    </option>
                    <option value="Ontario">
                      US - Central
                    </option>
                    <option value="Ontario">
                      US - West Coast
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Industry')"
                  >Industry</label>
                  <select
                    v-model.trim="$v.warehouse.industry.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.warehouse.industry.$error }"
                  >
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option
                      value="Food and Beverage"
                      v-html="$t('General.FoodBeverage')"
                    >
                      Food and Beverage
                    </option>
                    <option
                      value="Consumer Goods"
                      v-html="$t('General.ConsumerGoods')"
                    >
                      Consumer Goods
                    </option>
                    <option
                      value="E-commerce"
                      v-html="$t('General.eCommerce')"
                    >
                      eCommerce
                    </option>
                    <option
                      value="Manufacturing"
                      v-html="$t('General.Manufacturing')"
                    >
                      Manufacturing
                    </option>
                    <option
                      value="Healthcare"
                      v-html="$t('General.Health')"
                    >
                      Healthcare
                    </option>
                    <option
                      value="Retail Distribution"
                      v-html="$t('General.RetailDis')"
                    >
                      Retail Distribution
                    </option>
                    <option
                      value="Other"
                      v-html="$t('Quote.other')"
                    >
                      Other
                    </option>
                  </select>
                </div>
                      
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Inmethod')"
                  >Inbound method<br></label>
                  <select
                    v-model.trim="$v.warehouse.inbound.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.warehouse.inbound.$error }"
                  >
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option
                      value="Traile"
                      v-html="$t('Quote.trailer')"
                    >
                      Trailer
                    </option>
                    <option
                      value="Container"
                      v-html="$t('Quote.container')"
                    >
                      Container
                    </option>
                  </select>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.NumberofpalletsW')"
                  >Number of pallets <br> <span style="font-size:10px">stored at any given time, min. 200</span></label>
                  <input
                    v-model.trim="$v.warehouse.numpallets.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.warehouse.numpallets.$error }"
                  >
                </div>
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.weight')"
                  >Weight (in lbs)<br><span style="font-size:10px">max 2500 lbs per pallet</span></label>
                  <input
                    v-model.trim="$v.warehouse.palletweight.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.warehouse.palletweight.$error }"
                  >    
                  <label class="labelleft" />                    
                </div>    

                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.palletsize')"
                  >Pallet size<br> <br></label>
                  <select
                    v-model.trim="$v.warehouse.palletsize.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.warehouse.palletsize.$error}"
                  >
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option value="STANDARD 48x40">
                      Standard 48" x 40"
                    </option>
                    <option value="CHEP 48x40">
                      Chep 48" x 40"
                    </option>
                    <option value="HALF PALLET">
                      Half Pallet 48" x 20"
                    </option>
                    <option value="OVERSIZED">
                      Oversized
                    </option>
                  </select>                       
                </div>                 
              </div>


              <div
                class="row"
                style="padding:20px 0px 50px;"
              >
                <div class="col-md-4">
                  <label
                    class="labelleft" 
                    v-html="$t('Quote.inboundper', { 
                      inboundStart: Math.trunc(warehouse.sliders.inbound_per_month[0]), 
                      inboundEnd: Math.trunc(warehouse.sliders.inbound_per_month[1]) })"
                  >Inbound orders per month between <b>{{ Math.trunc(warehouse.sliders.inbound_per_month[0]) }}</b> and <b>{{ Math.trunc(warehouse.sliders.inbound_per_month[1]) }}</b></label>
                  <slider
                    v-model="warehouse.sliders.inbound_per_month"
                    type="dodgerblue" 
                    :connect="true"
                    :start="[10, 15]" 
                    :range="{ 'min': 5, 'max': 100 }"
                    :step="1"                                                      
                  />                        
                        
                  <!--
                        <label class="labelleft">Inbound orders<br><span style="font-size:10px">Amount per month, min 10</span></label>
                        <input class="custom_form" v-model.trim="$v.warehouse.inbound.$model" :class="{ 'custom_form error': $v.warehouse.inbound.$error}">                        
                        -->
                </div>
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.outboundper', { 
                      outboundStart: Math.trunc(warehouse.sliders.outbound_per_month[0]), 
                      outboundEnd: Math.trunc(warehouse.sliders.outbound_per_month[1]) })"
                  >Outbound orders per month between <b>{{ Math.trunc(warehouse.sliders.outbound_per_month[0]) }}</b> and <b>{{ Math.trunc(warehouse.sliders.outbound_per_month[1]) }}</b></label>
                  <slider
                    v-model="warehouse.sliders.outbound_per_month"
                    type="dodgerblue" 
                    :connect="true"
                    :start="[15, 20]" 
                    :range="{ 'min': 5, 'max': 100 }"
                    :step="1"                                                      
                  /> 
                  <!--
                        <label class="labelleft">Outbound orders<br><span style="font-size:10px">Amount per month, min 10</span></label>
                        <input class="custom_form" v-model.trim="$v.warehouse.numpallets.$model" :class="{ 'custom_form error': $v.warehouse.numpallets.$error }">                   
                        -->
                </div>
                <div class="col-md-4">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.prodturn', { 
                      turnsstart: Math.round(warehouse.sliders.turns_per_year[0]*2)/2 , 
                      turnsend: Math.round(warehouse.sliders.turns_per_year[1]*2)/2 })"
                  >Product turnover per year between <b>{{ Math.round(warehouse.sliders.turns_per_year[0]*2)/2 }}</b> and <b>{{ Math.round(warehouse.sliders.turns_per_year[1]*2)/2 }}</b></label>

                  <slider
                    v-model="warehouse.sliders.turns_per_year"
                    type="dodgerblue" 
                    :connect="true"
                    :start="[1.5, 2]" 
                    :range="{ 'min': 0.5, 'max': 24 }"                                                                             
                  />                       

                  <!--
                        <label class="labelleft">Product turnover<br><span style="font-size:10px">Amount per month</span></label>
                        <input class="custom_form" v-model.trim="$v.warehouse.inbound.$model" :class="{ 'custom_form error': $v.warehouse.inbound.$error}">                           
                        -->
                </div>
              </div>

              <div class="row"> 
                <div class="col-md-12">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.added')"
                  >Added value services</label>
                </div>      
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.edi">
                    <span>EDI</span>
                  </n-checkbox>
                </div>
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.pick">
                    <span v-html="$t('Quote.pickpack')">Pick and pack</span>
                  </n-checkbox>
                </div>               
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.fullpallet">
                    <span v-html="$t('Quote.fullpalpick')">Full pallet pick</span>
                  </n-checkbox>
                </div>
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.kit">
                    <span v-html="$t('Quote.Kitting')"> Kitting and assembly</span>
                  </n-checkbox>
                </div>
              </div>

              <div class="row">                                         
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.label">
                    <span v-html="$t('Quote.Labelling')">Labelling</span>
                  </n-checkbox>
                </div>     
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.rework">
                    <span v-html="$t('Quote.rework')">Rework and repair</span>
                  </n-checkbox>
                </div>
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.securing">
                    <span v-html="$t('Quote.secure')">Securing</span>
                  </n-checkbox>
                </div>                 
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.stack">
                    <span v-html="$t('Quote.Stackable')">Stackable pallets</span>
                  </n-checkbox>
                </div>
              </div>

              <div class="row"> 
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.floor">
                    <span v-html="$t('Quote.Floor')">Floor loaded and consolidation</span>
                  </n-checkbox>
                </div>
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.slip">
                    <span v-html="$t('Quote.Slip')">Slipsheet required</span>
                  </n-checkbox>
                </div>
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.top">
                    <span v-html="$t('Quote.Top')">Top sheet required</span>
                  </n-checkbox>
                </div>
                <div class="col-md-3">
                  <n-checkbox v-model="warehouse.checkboxes.chep">
                    <span v-html="$t('Quote.CHEP')">CHEP required</span>
                  </n-checkbox>
                </div>
              </div>

              <br>                 
              <label class="labelleft">Comments</label>
              <textarea
                v-model.trim="warehouse.info"
                class="custom_form"
                rows="4"
                required="required"
                data-error="Type Message Here "
                style="height:150px"
              />                                                                          
            </div>
          </div>

          <!-- TRANSPORTATION -->
          <div v-if="main.service === 'T'">  
            <div class="col-md-10 ml-auto mr-auto text-left">                                    
              <h3
                class="col-md-10 ml-auto mr-auto text-center"
                v-html="$t('Quote.TransFreight')"
              >
                Transportation<span class="tpgreen">.</span class="tpgreen"></span>
              </h3> 
              <!--<h1 class="title">Transportation</h1>-->
                    
              <div class="row">
                <div class="col-md-3">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.TranspType')"
                  >Transportation type</label>                                                             
                  <select
                    v-model.trim="$v.transport.type.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.transport.type.$error }"
                  >                      
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option
                      value="Dedicated"
                      v-html="$t('Quote.Dedicated')"
                    >
                      Dedicated fleets
                    </option>                          
                    <option
                      value="FTL"
                      v-html="$t('Quote.FTL')"
                    >
                      FTL - Full truckload
                    </option>
                    <option
                      value="LTL"
                      v-html="$t('Quote.LTL')"
                    >
                      LTL - Less than truckload
                    </option>
                    <option
                      value="Yard services"
                      v-html="$t('Quote.Yard')"
                    >
                      Yard services/Shunting
                    </option>                     
                    <option
                      value="Intermodal"
                      v-html="$t('Quote.Intermodal')"
                    >
                      Intermodal
                    </option>
                    <option
                      value="Drayage"
                      v-html="$t('Quote.Drayage')"
                    >
                      Drayage
                    </option>
                  </select>                        
                </div>
                <div class="col-md-3">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Servicelevel')"
                  >Service level</label>                                                             
                  <select
                    v-model.trim="$v.transport.service.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.transport.service.$error }"
                  >                      
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option
                      value="Regular"
                      v-html="$t('Quote.reg')"
                    >
                      Regular
                    </option>
                    <option
                      value="US-Interstate"
                      v-html="$t('Quote.Interstate')"
                    >
                      U.S. Interstate
                    </option> 
                    <option
                      value="Crossborder"
                      v-html="$t('Quote.Crossborder')"
                    >
                      Crossborder
                    </option>                          
                    <option
                      value="Expedited"
                      v-html="$t('Quote.Expedited')"
                    >
                      Expedited
                    </option>                           
                  </select>                        
                </div>                      
                <div class="col-md-3">                               
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Commodity')"
                  >Commodity</label>
                  <select
                    v-model.trim="$v.transport.commodity.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.transport.commodity.$error }"
                  >                      
                    <option
                      disabled
                      selected
                      value=""
                    />       
                    <option
                      value="Consumer goods"
                      v-html="$t('Quote.Consumergoods')"
                    >
                      Consumer goods
                    </option>                 
                    <option
                      value="Refrigerated"
                      v-html="$t('Quote.Foodgrade')"
                    >
                      Food grade
                    </option> 
                    <!--<option value="Refrigerated" v-html="$t('Quote.Refrigerated')">Refrigerated</option>                       -->
                    <option
                      value="Raw materials"
                      v-html="$t('Quote.Rawmaterials')"
                    >
                      Raw materials
                    </option>
                    <!--<option value="Hazardous materials" v-html="$t('Quote.Hazardousmaterials')">Hazardous materials</option>  -->
                  </select>                        
                </div>      
                <div class="col-md-3">                               
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Specializedequipment')"
                  >Specialized equipment</label>
                  <select
                    v-model.trim="transport.trailer.special"
                    class="custom_form"
                  >                      
                    <option
                      disabled
                      selected
                      value=""
                    />                        
                    <option
                      value="Container"
                      v-html="$t('Quote.Container')"
                    >
                      Container
                    </option>
                    <option value="Drop">
                      Double Drop
                    </option>
                    <option value="DryVan">
                      Dry Van
                    </option>
                    <option
                      value="Flatbed"
                      v-html="$t('Quote.Flatbed')"
                    >
                      FlatBed
                    </option>
                    <option value="LowBoy">
                      Lowboy / RGN
                    </option>
                    <option value="PowerOnly">
                      Power Only
                    </option>
                    <option
                      value="Refrigerated"
                      v-html="$t('Quote.Refrigerated')"
                    >
                      Refrigerated
                    </option>
                    <option
                      value="Residential"
                      v-html="$t('Quote.resident')"
                    >
                      Residential / Cube Van
                    </option>
                    <option value="RoleTite">
                      Role Tite / Conestoga
                    </option>
                    <option value="StepDeck">
                      Step Deck
                    </option>
                    <option
                      value="Straight body truck"
                      v-html="$t('Quote.Straightbodytruck')"
                    >
                      Straight body truck
                    </option>                          
                    <option value="SuperB/BTrain">
                      Super B / B-Train
                    </option>                          
                    <option
                      value="Tailgate"
                      v-html="$t('Quote.Tailgate')"
                    >
                      Tailgate
                    </option>                                                                                                    
                  </select>                        
                </div>                                        
              </div>

              <div class="row">  
                <div class="col-md-3">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.NumberofpalletsT')"
                  >Number of pallets </label>
                  <input
                    v-model.trim="$v.transport.numpallets.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.numpallets.$error }"
                  >                        
                </div>
                <div class="col-md-3">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.weight2')"
                  >Weight (in lbs) </label>
                  <input
                    v-model.trim="$v.transport.palletweight.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.palletweight.$error }"
                  >                        
                </div>    
                <div class="col-md-3">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.palletsize')"
                  >Pallet size </label>
                  <select
                    v-model.trim="$v.transport.palletsize.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.transport.palletsize.$error}"
                  >
                    <option
                      disabled
                      selected
                      value=""
                    />
                    <option value="STANDARD 48x40">
                      Standard 48" x 40"
                    </option>
                    <option value="CHEP 48x40">
                      Chep 48" x 40"
                    </option>
                    <option value="HALF PALLET">
                      Half pallet 48" x 20"
                    </option>
                    <option value="OVERSIZED">
                      Oversized
                    </option>
                  </select>                       
                </div>
                <div class="col-md-3">                               
                  <label
                    class="labelleft"
                    v-html="$t('Quote.FreightAttr')"
                  >Freight attributes</label>
                  <select
                    v-model.trim="$v.transport.attrib.$model"
                    class="custom_form"
                    required
                    :class="{ 'custom_form error': $v.transport.attrib.$error}"
                  >                      
                    <option
                      disabled
                      selected
                      value=""
                    />                        
                    <option
                      value="Stackable"
                      v-html="$t('Quote.Stackable')"
                    >
                      Stackable
                    </option>
                    <option
                      value="Non-stackablee"
                      v-html="$t('Quote.Nonstackable')"
                    >
                      Non-stackable
                    </option>
                    <option
                      value="Hazardous materials"
                      v-html="$t('Quote.Hazardousmaterials')"
                    >
                      Hazardous materials
                    </option>
                  </select>                        
                </div>                                         
              </div>
                                
              <br>
              <hr>
                    
              <div class="row">  
                <div class="col-md-12">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Origininfo')"
                  >Origin information</label>
                </div>
                <div class="col-md-4">                        
                  <input
                    v-model.trim="$v.transport.orig_address.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.orig_address.$error }"
                    :placeholder="$t('Address.address')"
                  >                         
                </div>                    
                <div class="col-md-4">                        
                  <input
                    v-model.trim="$v.transport.orig_city.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.orig_city.$error }"
                    :placeholder="$t('Address.city')"
                  >                        
                </div>
                <div class="col-md-4">                        
                  <input
                    v-model.trim="$v.transport.orig_zip.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.orig_zip.$error }"
                    :placeholder="$t('Address.postal')"
                  >                        
                </div> 
                <div class="col-md-12">                        
                  <input
                    v-model.trim="transport.orig_info"
                    class="custom_form"
                    :placeholder="$t('Address.pickupinfo')"
                  >
                </div>                                            
              </div>          

              <br>
              <hr>
                    
              <div class="row">                                                     
                <div class="col-md-12">
                  <label
                    class="labelleft"
                    v-html="$t('Quote.Destinationinfo')"
                  >Destination information</label>
                </div>
                <div class="col-md-4">                                                
                  <input
                    v-model.trim="$v.transport.dest_address.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.dest_address.$error }"
                    :placeholder="$t('Address.address')"
                  >                         
                </div>                    
                <div class="col-md-4">                        
                  <input
                    v-model.trim="$v.transport.dest_city.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.dest_city.$error }"
                    :placeholder="$t('Address.city')"
                  >                        
                </div>
                <div class="col-md-4">                        
                  <input
                    v-model.trim="$v.transport.dest_zip.$model"
                    class="custom_form"
                    :class="{ 'custom_form error': $v.transport.dest_zip.$error }"
                    :placeholder="$t('Address.postal')"
                  >                        
                </div>
                <div class="col-md-12">                        
                  <input
                    v-model.trim="transport.dest_info"
                    class="custom_form"
                    :placeholder="$t('Address.deliveryinfo')"
                  >                        
                </div>                                                                     
              </div>  

              <br>                 
              <label
                class="labelleft"
                v-html="$t('Quote.Comments')"
              >Comments</label>
              <textarea
                v-model.trim="warehouse.info"
                class="custom_form"
                rows="4"
                required="required"
                data-error="Type Message Here"
                style="height:150px"
              />                                                                          
            </div>
          </div>
        </tab-content>

        <!-- CONTACT -->
        <tab-content
          :title="$t('Quote.Contact')"
          icon="now-ui-icons users_single-02"
          :before-change="()=>{ return validateStep3() }"
        >
          <div class="col-md-4 ml-auto mr-auto text-left">                                    
            <h3 class="col-md-10 ml-auto mr-auto text-center">
              Contact<span class="tpgreen">.</span class="tpgreen"></span>
            </h3>            
            <!--<h1 class="title">Contact</h1>-->

            <div class="row">
              <label
                class="labelleft"
                v-html="$t('Contact.Name')"
              >Name</label>
              <input
                v-model.trim="$v.contact.name.$model"
                class="custom_form"
                :class="{ 'custom_form error': $v.contact.name.$error }"
              >              

              <label
                class="labelleft"
                v-html="$t('Contact.Phone')"
              >Phone number</label>
              <input
                v-model.trim="$v.contact.phone.$model"
                type="tel"
                placeholder="123-456-7890"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                required
                class="custom_form"
                :class="{ 'custom_form error': !$v.contact.phone.isPhone && $v.contact.phone.$error }"
              > 

              <label
                class="labelleft"
                v-html="$t('Contact.Email')"
              >Email</label>
              <input
                v-model.trim="$v.contact.email.$model"
                class="custom_form"
                :class="{ 'custom_form error': $v.contact.email.$error }"
              >

              <label
                class="labelleft"
                v-html="$t('Contact.Company')"
              >Company name</label>
              <input
                v-model.trim="$v.contact.company.$model"
                class="custom_form"
                :class="{ 'custom_form error': $v.contact.company.$error }"
              >                                               

              <!--
                  <label class="labelleft" v-html="$t('Contact.Position')">Position</label>
                  <input class="custom_form" :class="{ 'custom_form error': $v.contact.position.$error }" v-model.trim="$v.contact.position.$model"> 
                  -->

              <label
                class="labelleft"
                v-html="$t('Contact.BestTime')"
              >Best time to contact you</label>
              <input
                v-model.trim="contact.best"
                class="custom_form"
              > 

              <label
                class="labelleft"
                v-html="$t('Contact.Additional')"
              >Additional information</label>                  
              <textarea
                v-model.trim="$v.contact.info.$model"
                class="custom_form"
                rows="4"
                required="required"
                style="height:300px"
                :class="{ 'custom_form error': $v.contact.info.$error }"
              />                                
              <span style="font-size:10px">required characters {{ contact.info.length }} / 50</span>
            </div>
          </div>                
        </tab-content>

            
        <button
          slot="back"
          class="wizard-btn bluebutton"
          style="background-color: dodgerblue; border-color: dodgerblue; color: white;"
        >
          Back
        </button>
        <button
          slot="next"
          class="wizard-btn bluebutton"
          style="background-color: dodgerblue; border-color: dodgerblue; color: white;"
        >
          Next
        </button>
      </form-wizard>
    </div>
  </div>  
</template>
<script>
import {  NavLink, Card } from '@/components';
import axios from 'axios'
import { required, minLength, between, minValue, maxValue, email } from 'vuelidate/lib/validators'
const isPhone = (value) => /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(value);  //phone valid

//local registration
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch
} from '@/components';

export default {
  name: 'Quote',
  components: {
    Card,    
    FormWizard,
    TabContent,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    Slider    
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',          
      name: '',
      age: 0,
      main: {
        warehouse: false,
        transport: false,
        service: '',
        services: [
          { img: 'img/bg1.jpg', val: 'W', name: 'Warehousing and Distribution'},
          { img: 'img/bg4.jpg', val: 'T', name: 'Transportation and Freight Services'},           
        ]
      },
      warehouse: {
        location: '',
        industry:  '',
        numpallets: '',
        palletsize: '',
        palletweight: '',
        inbound: '',
        turns: '',
        info: '',
        sliders: {
          inbound_per_month: [10, 15],
          outbound_per_month: [15, 20],
          turns_per_year: [1.5, 2]
        },
        checkboxes: {
          edi: false,
          pick: false,
          fullpallet: false,
          kit: false,
          label: false,        
          rework: false,
          securing: false,
          stack: false,
          floor: false,
          slip: false,
          chep: false,
        } 
      },
      transport: {
        type: '',
        service: '',
        frequency: '',
        numpallets: '',
        palletsize: '',
        palletweight: '',      
        orig_city: '',
        orig_address: '',
        orig_zip: '',
        orig_info: '',
        dest_city: '',
        dest_address: '',
        dest_zip: '',
        dest_info: '',
        trailer: '',
        commodity: '',
        attrib: '',
        special: ''
      },
      frieght: {        
      },
      contact: {
        name: '',
        email: '',
        phone: '',
        company: '',
        /*position: '',*/
        info: '',
        best:''
      }
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    age: {        
      between: between(16, 110)
    },
    warehouse: {
      location: { required },
      industry: { required },
      inbound: { required },
      numpallets: { required, minValue: minValue(100) },
      palletsize: { required },
      palletweight: { maxValue: between(1, 2500) },      
      /*outbound: { required, minValue: minValue(10) }*/
    },
    transport: {
      type: { required },
      service: {required },
      frequency: { required },
      numpallets: { required },
      palletsize: { required },
      palletweight: { required },
      orig_city: { required },
      orig_address: { required },
      orig_zip: { required },      
      dest_city: { required },
      dest_address: { required },
      dest_zip: { required },         
      trailer: { required },
      commodity: { required },
      attrib: {required }
    },
    contact: {
      name: { required },
      email: { required, email },
      phone: { 
        required,
        isPhone(value) {          
          // alert(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(value))          

          /*
          return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(value)
          
          123-456-7890
          (123) 456-7890
          123 456 7890
          123.456.7890
          +91 (123) 456-7890
          */

          return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(value)
          /*
          18005551234
          1 800 555 1234
          +1 800 555-1234
          +86 800 555 1234
          1-800-555-1234
          1 (800) 555-1234
          (800)555-1234
          (800) 555-1234
          (800)5551234
          800-555-1234
          800.555.1234
          800 555 1234x5678
          8005551234 x5678
          1    800    555-1234
          1----800----555-1234
          */
        }      
       },
      company: { required },
      //position: { required },
      info: { required, minLength: minLength(50) }
    }    
  },
 
  mounted (){
    this.hidebutton(true)       
    //alert(this.$refs.wizard.activeTabIndex)
  },
  methods: {
      onChangeService(val) {
          this.hidebutton(false)  
          //alert(val)
          this.main.service = val;              
          //this.main.service = event.target.value;                        
          //this.$refs.stepone.changeTab(0, 1)
          this.$refs.wizard.changeTab(0, 1)
      },
      hidebutton(val) {                
        document.querySelectorAll('.bluebutton').forEach( e => {
          e.classList.toggle("hidenext",val)
        })        
      },  
      onComplete() {        
        var d;
        switch(this.main.service) {
          case 'W':
            d = this.warehouse
            d.DIVISION = 'WAREHOUSE'
            break;
          case'T':
            d = this.transport
            d.DIVISION = 'TRANSPORT'
            break;
          default:
            // code block
        }

        axios.post('https://api.transplus.com/requestaquote/', {data: d, contact: this.contact} )
        .then((response) => {
          //alert(JSON.stringify(response))          
          alert("Message Sent")
          this.$router.go('/');
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })   
      },
      validateStep1() {          
          
          this.$v.$reset() // reset the touch
          if (this.main.service) {                        
            return true;
          }          
          return false;
      },
      validateStep2() {
        
        return ((this.main.service === 'W')? this.validateWarehouse() : this.validateTransport())
      },
      validateStep3() {
        
        this.$v.contact.$touch()
        window.scrollTo(0, 0)
        return (
          !this.$v.contact.name.$error &&
          !this.$v.contact.email.$error &&
          !this.$v.contact.phone.$error &&
          !this.$v.contact.company.$error &&
          //!this.$v.contact.position.$error &&
          !this.$v.contact.info.$error
        )
      },      
      validateWarehouse() {
          
          this.$v.warehouse.$touch() /* error initially false until touched = true is theres an error */
          window.scrollTo(0, 0)
          return ( 
            (!this.$v.warehouse.location.$error && !this.$v.warehouse.location.$invalid ) && 
            (!this.$v.warehouse.industry.$error && !this.$v.warehouse.industry.$invalid ) && 
            (!this.$v.warehouse.numpallets.$error && !this.$v.warehouse.numpallets.$invalid ) && 
            (!this.$v.warehouse.palletsize.$error && !this.$v.warehouse.palletsize.$invalid ) && 
            (!this.$v.warehouse.palletweight.$error && !this.$v.warehouse.palletweight.$invalid ) && 
            (!this.$v.warehouse.inbound.$error && !this.$v.warehouse.inbound.$invalid )
          );
      },
      validateTransport() {
          
          this.$v.transport.$touch() /* error initially false until touched = true is theres an error */
          window.scrollTo(0, 0)

          return ( 
            (!this.$v.transport.type.$error  ) && 
            
            (!this.$v.transport.numpallets.$error ) && 
            (!this.$v.transport.palletsize.$error ) && 
            (!this.$v.transport.palletweight.$error ) && 
            
            (!this.$v.transport.orig_address.$error ) && 
            (!this.$v.transport.orig_city.$error ) && 
            (!this.$v.transport.orig_zip.$error ) && 

            (!this.$v.transport.dest_address.$error ) && 
            (!this.$v.transport.dest_city.$error ) && 
            (!this.$v.transport.dest_zip.$error )            
          );
      }
  }
}
</script>

<style scoped>
  ::placeholder {
    color: rgb(205, 205, 205);
  }
  label {
    margin-top:15px;
  }

  .hidenext {
    visibility: hidden;
  }

  .card-title{
    text-align:center; font-size:1.25em
  }

  /*-- --*/
  .imgservices{
    filter: grayscale(50%);
    width:200; 
  }
  .imgautoheight{
    background-size: auto 200px;
  }
  .imgboxshadow{
    box-shadow: 1px 3px 14px 2px rgba(0,0,0,0.15);
  }
  /*-- */

  .custom_form {    
    border:1px solid #333;
    width: 100%;
    padding: 12px 20px;
    margin-bottom: 8px;
    
  }

  .custom_form:focus {
      outline: none !important;
      border:1px solid #55B550;
      box-shadow: 0 0 4px #55B550;
  }
  .error {
      border:1px solid #800020;
      box-shadow: 0 0 4px #800020 ;
  }

  .hoverblue {
    color: #999;
    background-color: rgb(245, 245, 245);
    border-width: 0;
    font-weight: bold;
    font-size: 12px;    
    margin: 20px 1px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  .hoverblue:hover{
    color: white;
    background-color: dodgerblue;
  }
  .turngreen {
    transition: 0.3s;
    margin:10px;
  }
  .turngreen:hover {
    background-color:#55B550; 
    color:white; 
    border-radius: 5px;
    margin-bottom:10px;
  }
  .labelleft{
    text-align:left;
  }
  /* ------custom checkbox --------- */
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: dodgerblue;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }



/* HIDE RADIO */
[type=radio] { 
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

/* IMAGE STYLES */
[type=radio] + img {
    cursor:pointer;
    width:98%;
    background-size:contain;
    background-repeat:no-repeat;
    /*
    -webkit-transition: all 100ms ease-in;
       -moz-transition: all 100ms ease-in;
            transition: all 100ms ease-in;
    -webkit-filter: brightness(1.8) grayscale(1) opacity(.7);
       -moz-filter: brightness(1.8) grayscale(1) opacity(.7);
            filter: brightness(1.8) grayscale(1) opacity(.7);
    */
}

/* CHECKED STYLES */
[type=radio]:checked + img {
  width: 270px;
  /*box-shadow:0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19) !important;*/
  color:white;
  /*outline: 2px solid #55B550;  */
  -webkit-filter: none;
      -moz-filter: none;
          filter: none;  
}
[type=radio]:hover + img {
  width: 270px;
  /*box-shadow:0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19) !important;*/
  color:white;
  /*outline: 2px solid #55B550;  */
  -webkit-filter: none;
      -moz-filter: none;
          filter: none;  
}


.select {
  text-align:center;
  font-size: 1.25em;
  font-weight: 700;
  width: 270px;
}

.select:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  text-align: center;
}


.features-text {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  font-size: 20px;
  min-height: 48px;
}
@media only screen  and (max-width:768px) {  
  .card-title{
    text-align:center; 
    font-size:1em
  }
}
</style>